'use client';

import { Caption } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import styles from '@/app/[locale]/products/[slug]/components/ProductBadges/styles.module.css';
import { LocaleCurrencyFormat } from '@/components/LocaleCurrencyFormat';
import { type CurrencyCode } from '@/modules/currencies/constants';
import {
  type ShippingDiscounts,
  ShippingDiscountType,
} from '@/modules/product/aliases';

export function SellerSubsidisedShippingBadge({
  currencyName,
  shippingDiscount,
}: {
  currencyName?: CurrencyCode;
  shippingDiscount?: ShippingDiscounts;
}) {
  const t = useTranslations('product');

  if (!shippingDiscount?.national_shipping) {
    return;
  }

  if (
    shippingDiscount.national_shipping.discount_type ===
    ShippingDiscountType.FREE_SHIPPING
  ) {
    return (
      <Caption variant="sm-bold" className={styles.discountLabel} as="span">
        {t('FreeShipping')}
      </Caption>
    );
  }

  return (
    <Caption variant="sm-bold" className={styles.discountLabel} as="span">
      {t.rich('SellerCoverShippingAmount', {
        shippingAmount: () => (
          <LocaleCurrencyFormat
            currencyCode={currencyName}
            numberToFormat={
              shippingDiscount.national_shipping?.discount_amount ?? 0
            }
            stripDecimalsIfWholeNumber
          />
        ),
      })}
    </Caption>
  );
}
